<template>
  <div>
    <el-card>
      <el-input
        v-model="username"
        size="small"
        class="mr20"
        placeholder="请输入账号名"
      ></el-input>
      <el-button
        size="small"
        class="mr20"
        :disabled="!username"
        type="primary"
        @click="unfreezing"
        >解冻</el-button
      >
      <el-button
        size="small"
        :disabled="!username"
        type="danger"
        @click="freezing"
        >冻结</el-button
      >
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    async unfreezing() {
      await this.$store.dispatch("accountUnfreezing", {
        username: this.username
      });
      this.$message({
        type: "success",
        message: "解冻成功"
      });
    },
    async freezing() {
      const result = await this.$confirm("确认冻结账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("accountFreezing", {
          username: this.username
        });
        this.$message({
          type: "success",
          message: "冻结成功"
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
